<div>
	@for (item of items; track $index) {
		<app-list-item
			[enableSelect]="enableSelect"
			[enableUpDown]="enableUpDown"
			[enableCopy]="enableCopy"
			[enableEdit]="enableEdit"
			[enableDelete]="enableDelete"
			[enablePreview]="enablePreview"
			[itemUuidName]="itemUuidName"
			[enableClickAsEdit]="enableClickAsEdit"
			[class.selected]="selectedUuid !== undefined && (selectedUuid === item.uuid || selectedUuid === item.id)"
			[item]="item"
			[isLeaf]="isLeaf"
			[isInProgress]="isInProgress(item)"
			[prefix]="prefix"
			(onSelect)="select(item)"
			(onCopy)="copy($event)"
			(onDelete)="delete($event)"
			(onEdit)="edit($event)"
			(onMoveUp)="moveUp($event)"
			(onMoveDown)="moveDown($event)"
		>
			<ng-container *ngTemplateOutlet="template; context: { $implicit: item }"></ng-container>
		</app-list-item>
	}
</div>
